import { render, staticRenderFns } from "./Validate.vue?vue&type=template&id=6e207c03&scoped=true&"
import script from "./Validate.vue?vue&type=script&lang=js&"
export * from "./Validate.vue?vue&type=script&lang=js&"
import style0 from "./Validate.vue?vue&type=style&index=0&id=6e207c03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e207c03",
  null
  
)

export default component.exports